(() => {
  if (customElements.get('kraven-halloween-bar')) return;
  const clocks = new Set();
  let timer = 0;
  const stopTimer = () => {if(timer) clearInterval(timer);timer=0;};
  const tick = () => {
    const now = Date.now();
    clocks.forEach(clock => clock.update(now));
    if (!clocks.size) stopTimer();
  };
  const runTimer = () => {
    if (!timer && clocks.size && !document.hidden) timer = setInterval(tick,250);
  };
  document.addEventListener('visibilitychange',() => {
    if (document.hidden) stopTimer();
    else {tick();runTimer();}
  });
  class KravenHalloweenBar extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      const source = document.querySelector('kraven-halloween-bar[data-deadline]');
      this.deadline = Date.parse(source?.dataset.deadline || this.dataset.deadline || '');
      this.clock = this.querySelector('.kraven-halloween-clock');
      this.copy = this.querySelector('[data-event-copy]');
      this.fields = ['days','hours','minutes','seconds'].map(name => this.querySelector('[data-clock-' + name + ']'));
      this.start();
    }
    update(now = Date.now()) {
      if (!Number.isFinite(this.deadline)) {
        if (this.clock) this.clock.hidden = true;
        this.stop();
        return;
      }
      const total = Math.max(0, Math.ceil((this.deadline - now) / 1000));
      if (total === 0) {
        if (this.clock) this.clock.hidden = true;
        document.querySelectorAll('[data-halloween-sale-notice]').forEach(notice => {notice.hidden = true;});
        if (this.copy) this.copy.textContent = this.dataset.expired || '';
        this.stop();
        return;
      }
      const values = [Math.floor(total/86400),Math.floor(total/3600)%24,Math.floor(total/60)%60,total%60];
      this.fields.forEach((field,i) => {
        const value = String(values[i]).padStart(2,'0');
        if(field && field.textContent !== value) field.textContent = value;
      });
    }
    start() {
      clocks.add(this);
      tick();
      runTimer();
    }
    stop() {clocks.delete(this);if(!clocks.size) stopTimer();}
    disconnectedCallback() {
      this.stop();
      this._ready=false;
    }
  }
  customElements.define('kraven-halloween-bar',KravenHalloweenBar);
  customElements.define('kraven-halloween-cart-clock',class extends KravenHalloweenBar {});
})();


(() => {
  if (window.__kravenHalloweenArt) return;
  const art = {
    frame: 0,
    seen: new WeakSet(),
    schedule() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {this.frame = 0; this.position();});
    },
    position() {
      if (!this.decor || !this.header) return;
      const mobile = matchMedia('(max-width:749px)').matches;
      const docked = this.section.classList.contains('kraven-header--floating') && !document.body.classList.contains('kraven-cinematic-header-active');
      const box = this.header.getBoundingClientRect();
      const frame = document.querySelector('.page-wrapper');
      const width = frame?.clientWidth || document.documentElement.clientWidth;
      const frameLeft = frame ? Math.max(0,frame.getBoundingClientRect().left) : 0;
      const x = docked ? (mobile ? 8 : frameLeft + Math.max(16,(width - 1280)/2)) : Math.max(0,box.left);
      const y = docked ? 11 : 0;
      const scale = docked ? (mobile ? .94 : .88) : 1;
      for (const [name,value] of [['x',x+'px'],['y',y+'px'],['scale',String(scale)]]) {
        const key = '--halloween-art-'+name;
        if(this.decor.style.getPropertyValue(key) !== value) this.decor.style.setProperty(key,value);
      }
      this.decor.dataset.docked = String(docked);
    },
    mount() {
      const incoming = document.querySelector('#header-component .kraven-halloween-decor');
      if (incoming) {
        if(this.decor && this.decor !== incoming) this.decor.remove();
        this.decor = incoming;
        document.body.append(incoming);
      }
      this.header = document.querySelector('#header-component');
      this.section = document.querySelector('.header-section');
      if (!this.header || !this.decor || !this.section) return;
      this.observer?.disconnect();
      this.observer = new MutationObserver(() => this.schedule());
      this.observer.observe(this.section,{attributes:true,attributeFilter:['class']});
      this.observer.observe(document.body,{attributes:true,attributeFilter:['class']});
      this.resizeObserver?.disconnect();
      this.resizeObserver = new ResizeObserver(() => this.schedule());
      this.resizeObserver.observe(document.querySelector('.page-wrapper') || this.header);
      const template = document.querySelector('#kraven-halloween-surface-template');
      if(template) {
        for(const outer of document.querySelectorAll('main > .shopify-section,.shopify-section-group-footer-group')) {
          if(outer.querySelector('.kraven-scroll-hero,.kraven-halloween-surface-art')) continue;
          const surface = [...outer.children].find(el => el.tagName === 'SECTION') || outer;
          surface.classList.add('kraven-halloween-surface');
          const layer = document.createElement('div');
          layer.className = 'kraven-halloween-surface-art';
          layer.setAttribute('aria-hidden','true');
          layer.append(template.content.cloneNode(true));
          surface.append(layer);
        }
      }
      this.position();
    },
    async celebrate(event) {
      if(event.action !== 'add' || !event.promise || this.seen.has(event.promise)) return;
      this.seen.add(event.promise);
      try {
        const result = await event.promise;
        if(result?.detail?.didError || !result?.cart || document.hidden || matchMedia('(prefers-reduced-motion:reduce)').matches) return;
        if(this.lastGhost && Date.now()-this.lastGhost < 1400) return;
        const template = document.querySelector('#kraven-halloween-ghost-template');
        if(!template) return;
        this.lastGhost = Date.now();
        const ghost = document.createElement('span');
        ghost.className = 'kraven-halloween-ghost';
        ghost.setAttribute('aria-hidden','true');
        ghost.append(template.content.cloneNode(true));
        document.body.append(ghost);
        ghost.addEventListener('animationend',()=>ghost.remove(),{once:true});
        setTimeout(()=>ghost.remove(),1500);
      } catch {}
    }
  };
  window.__kravenHalloweenArt = art;
  document.addEventListener('scroll',()=>art.schedule(),{passive:true,capture:true});
  window.addEventListener('resize',()=>art.schedule(),{passive:true});
  document.addEventListener('shopify:section:load',()=>art.mount());
  document.addEventListener('shopify:cart:lines-update',event=>art.celebrate(event));
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>art.mount(),{once:true});
  else art.mount();
})();



